import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import createMarkup from '../../../../_utils/murkup';


const CollectionAuthorModal = ({ name, photo, about, show, handleClose }) => {

  return(
    <Modal show={ show } onHide={ handleClose } size='lg' className={'cabinet-author-card__modal'}>
      <Modal.Header closeButton>
        <Modal.Title>
          { name }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { photo && <img src={ photo } alt={'user photo'} align={'left'} className={'mr-2 mb-2'}/> }
        <div dangerouslySetInnerHTML={ createMarkup(about) }></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ handleClose }>
          { gettext('Закрыть') }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CollectionAuthorModal;
